import React, { Component } from 'react';
import Cleave from 'cleave.js/react';
import CleavePhone from 'cleave.js/dist/addons/cleave-phone.fr';
import Formaters from '../../common/Formaters';
import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required, mustMatch, minLength, regexMatch, emptyRegexMatch } from '../Validation/Rules';
import RegexValidator from '../Validation/RegexValidator';
import FileBase64 from 'react-file-base64';
import Config from "../../config"

const fieldValidations = [
  RuleRunner("iban", "L'IBAN'", required, regexMatch(RegexValidator.iban, "L'IBAN' est incorrect")),
  RuleRunner("bic", "Le BIC", required, regexMatch(RegexValidator.bic, "Le BIC est incorrect")),
  RuleRunner("file", "Le RIB", required),
];

export default class AccountInformation extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      account: props.account,
      validationErrors: { },
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    var account = this.state.account;
    const name = event.target.name;
    
    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    let value = event.target.rawValue;

    if (value === null || value === undefined) {
      value = event.target.value;
    }

    if (value === "on") {
      value = event.target.checked
    }

    // Update the businessHour object
    if (typeof value === "string"){
      value = value.toUpperCase();
    }
    account[name] = value;

    this.setState({
      account: account
    });

    //this.checkForm();
  }

  checkForm() {
    var errors = Run(this.state.account, fieldValidations);

    for(let i=0; i<Config.program.debitAuth.length; i++){
      if (!this.state.account["debitauth_"+i]){
        errors["debitAuth"] = "Vous devez autoriser les prélèvements pour les différents organismes";
        break;
      }
    }

    this.setState({
      validationErrors: errors
    });

    return Object.keys(errors).length === 0;
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  getObject() {
    return this.state.account;        
  }

  // Callback~
  getFiles(file) {
    let account = this.state.account;
    account.file = file;
    this.setState({ account: account })  
  }

  render() {

    let ctx = this;
    let domAuth = Config.program.debitAuth.map(function(name, i){
      return <tr className="form-group" key={i}>
        <td>
          <label className="switch margin-left-s">
            <input className={"switch-checkbox switch-checkbox-program-"+Config.program.style}  id={"debitauth_" + i}  name={"debitauth_" + i} type="checkbox" onChange={ctx.handleChange}/>
            <span className="switch-slider round"></span>
          </label>
          <label  for={"debitauth_" + i} className="label-big">J'autorise les prélèvements sur le compte bancaire par {name}</label>
        </td>
      </tr>
    })
    return (
      <fieldset className="form-fieldset">
        <legend className="form-fieldset-legend">Informations bancaire</legend>
        <div className="row">
          <div className="mycol-6">
            <div className="form-group">
              <label className="label" htmlFor="iban">IBAN</label>
              <Cleave id="iban" name="iban" type="text" placeholder="IBAN" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                value={this.state.account.iban}
                options={Formaters.iban}
                required
              />
              <span className="form-error">{this.errorFor("iban")}</span>
            </div>
          </div>
          <div className="mycol-6">
            <div className="form-group">
              <label className="label" htmlFor="bic">BIC</label>
              <Cleave id="bic" name="bic" type="text" placeholder="BIC" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                value={this.state.account.bic}
                options={Formaters.bic}
                required
              />
              <span className="form-error">{this.errorFor("bic")}</span>
            </div>
          </div>
        </div>   
        <div className="row">
          <div className="mycol-12 text-center">
            <div className="form-group">
              <label htmlFor="bic">Veuillez joindre un relevé d'identité bancaire : </label>
              <FileBase64 
                multiple={false} onDone={this.getFiles.bind(this)}
              />
              <div className="form-error">{this.errorFor("file")}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <table>
            {domAuth}
          </table>
        </div>
        <div className="form-error">{this.errorFor("debitAuth")}</div>
      </fieldset>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Forms/AccountInformation.js